import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import {
    CalendarIcon,
    ChevronRightIcon,
    ExternalLinkIcon,
    PhoneIcon,
    UsersIcon,
} from '@heroicons/vue/solid';
import { MetaIntegrationService } from '@/services';
import { toastServiceError } from '@/services/core/notification';
import { MetaWaba, MetaWhatsAppNumberPolicy, WhatsAppWabaStatusColorMap } from '@/types';
import { formatDateAsString } from '@/utils/datetime';
import { attendanceUrl } from '@/configs';
import { operatingPhoneCount, wabaStatus } from '@/utils/whatsappMeta';
import CompanyPhoneQuotaSummary from './components/CompanyPhoneQuotaSummary.vue';
import WhatsAppMetaHeader from './components/WhatsAppMetaHeader.vue';

const perPage = 10;


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsAppMetaListPage',
  setup(__props, { expose: __expose }) {
  __expose();

const router = useRouter();
const { t } = useI18n();
const wabas = ref<MetaWaba[]>([]);
const policy = ref<MetaWhatsAppNumberPolicy | null>(null);
const currentPage = ref(1);
const paginatedWabas = computed(() => {
    const start = (currentPage.value - 1) * perPage;
    return wabas.value.slice(start, start + perPage);
});

const openWaba = (wabaId: string) => {
    router.push({ name: 'WhatsAppMetaDetail', params: { wabaId } });
};

const loadPolicy = async () => {
    try {
        policy.value = (await MetaIntegrationService.getWhatsAppNumberPolicy()).data;
    } catch {
        policy.value = null;
    }
};

const load = async () => {
    loadPolicy();
    try {
        const { data } = await MetaIntegrationService.getWabas();
        wabas.value = data;
    } catch (error) {
        toastServiceError(error);
    }
};

onMounted(load);

const __returned__ = { router, t, wabas, policy, currentPage, perPage, paginatedWabas, openWaba, loadPolicy, load, get CalendarIcon() { return CalendarIcon }, get ChevronRightIcon() { return ChevronRightIcon }, get ExternalLinkIcon() { return ExternalLinkIcon }, get PhoneIcon() { return PhoneIcon }, get UsersIcon() { return UsersIcon }, get WhatsAppWabaStatusColorMap() { return WhatsAppWabaStatusColorMap }, get formatDateAsString() { return formatDateAsString }, get attendanceUrl() { return attendanceUrl }, get operatingPhoneCount() { return operatingPhoneCount }, get wabaStatus() { return wabaStatus }, CompanyPhoneQuotaSummary, WhatsAppMetaHeader }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})